<template>
  <div class="mm-row-block">
    <el-form label-width="100px" label-position="left">
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>基本資料</h3>
        </div>
        <div class="form-isheader-group-content">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="舊會員編號" prop="old_customer_num">
                <el-input disabled="" v-model="data.old_customer_num">
                  <el-button slot="append" @click="copyText(data.old_customer_num)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="電話號碼" prop="phone">
                <el-input disabled="" v-model="data.phone">
                  <el-button slot="append" @click="copyText(data.phone)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="會員姓名" prop="name">
                <el-input disabled="" v-model="data.name">
                  <el-button slot="append" @click="copyText(data.name)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="英文名稱" prop="ename">
                <el-input disabled="" clearable v-model="data.ename">
                  <el-button slot="append" @click="copyText(data.ename)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="稱謂" prop="appellations">
                <el-select class="elselect" disabled="" v-model="data.appellations" clearable placeholder="請選擇" :popper-append-to-body="false">
                  <el-option :label="'先生'" :value="1"></el-option>
                  <el-option :label="'女士'" :value="2"></el-option>
                  <el-option :label="'小姐'" :value="3"></el-option>
                  <el-option :label="'太太'" :value="4"></el-option>
                  <el-option :label="'其他'" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="國籍" prop="country_id">
                <el-input v-if="data.country_ename && data.country_twname" disabled="" :value="data.country_ename+'-'+data.country_twname"></el-input>
                <el-input v-else disabled=""></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="身份證或護照" prop="card">
                <el-input disabled="" v-model="data.card">
                  <el-button slot="append" @click="copyText(data.card)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="住址" prop="address">
                <el-input disabled="" v-model="data.address">
                  <el-button slot="append" @click="copyText(data.address)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="代理" prop="agent">
                <div style="margin:10px 0">
                  <el-switch style="display: block" disabled v-model="data.agent" active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否" active-value="1" inactive-value="0">
                  </el-switch>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="備註" prop="remarks">
                <el-input disabled="" v-model="data.remarks">
                  <el-button slot="append" @click="copyText(data.remarks)" type="primary" icon="el-icon-document-copy"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div v-if="createinfo">
            <div class="mm-row ">
              <div class="mm-col flex50">
                <el-form-item label="風險評估" prop="risk_level">
                  <div v-if="data.risk_level==2" class="text-red">
                    {{data.risk_level_text}}
                  </div>
                  <div v-if="data.risk_level==1" class="text-orange">
                    {{data.risk_level_text}}
                  </div>
                  <div v-if="data.risk_level==0" class="text-green">
                    {{data.risk_level_text}}
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row ">
              <div class="mm-col flex50">
                <el-form-item label="狀態" prop="status">
                  <div :class="data.status==2?'text-red':(data.status==1?'text-orange':'text-green')">
                    {{data.status_text}}
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row ">
              <div class="mm-col flex50">
                <el-form-item label="積分" prop="integral">
                  <span>{{data.integral}}</span>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row ">
              <div class="mm-col flex50">
                <el-form-item label="建立MSO" prop="mso">
                  <span>{{data.mso.name}}</span>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row ">
              <div class="mm-col flex50">
                <el-form-item label="建立門市" prop="store">
                  <span>{{data.store.short+' '+data.store.name}}</span>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row ">
              <div class="mm-col flex50">
                <el-form-item label="建立員工" prop="user">
                  <span>{{data.user.username+'('+data.user.name+')'}}</span>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row ">
              <div class="mm-col flex50">
                <el-form-item label="建立時間" prop="addtime_text">
                  <span>{{data.addtime_text}}</span>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-isheader-group">
        <div class="group-title">
          <h3>會員文件</h3>
        </div>
        <div class="form-isheader-group-content">
          <div class="flex-start">
            <h3 style="margin-right:20px">上傳要求:</h3>
            <div class="notice">支持JPEG、JPG、PNG、PDF文件上傳</div>
          </div>
          <component :type="type" :showdata.sync="files1" :files.sync="customer_files2" :disabled="isreadonly" :is="component_name"></component>

        </div>
      </div>
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>審查結果 Name Screening Result</h3>
        </div>
        <div class="form-isheader-group-content">
          <template v-if="examineStatus()">
            <div v-if="dowjones" style="margin-bottom: 20px;">
              <div class="group-sub-title">
                <div class="dowjones-logo"><img src="@/assets/dowjones_s.png"></div>
              </div>
              <el-table empty-text="暫無數據" :data="dowjonesdata" border :header-cell-style="{background:'#FAFAFA'}">
                <el-table-column align="center">
                  <template slot-scope="scope">
                    <div class="phonecel"></div>
                    <span :class="riskicon_color(scope.row.riskicon)">{{scope.row.riskicon}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="名稱" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">名稱</div>
                    <div class="dowjonesdata_primaryname">
                      <span>{{scope.row.primaryname}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="檔案簡要" width="300px" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">檔案簡要</div>
                    <template v-for="(item,i) in scope.row.content">
                      <div :key="i" style="text-align:left;">
                        檔案編號：{{item.peid}} <br>符合姓名：{{item.matchedname}} <br>匹配性別：{{item.gender}} <br>出生日期：{{item.birthday}} <br>匹配精度：{{item.matchtype}}
                      </div>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column label="國家/地區" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">國家/地區</div>
                    <span>{{scope.row.country}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="標題" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">標題</div>
                    <span>{{scope.row.title}}</span>
                  </template>
                </el-table-column>

                <el-table-column label="子公司" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">子公司</div>
                    <span>{{scope.row.subsidiary}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Score" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">Score</div>
                    <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                    <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                    <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="查詢時間" align="center">
                  <template slot-scope="scope">
                    {{scope.row.addtime}}
                  </template>
                </el-table-column>
                <el-table-column label="详细" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">详细</div>
                    <span>
                      <el-button @click="showdowjones_info_fun(scope.row.content[0].peid,0)">查看</el-button>
                    </span>

                  </template>
                </el-table-column>
              </el-table>
              <el-dialog :visible.sync="showdowjones" :append-to-body='true'>
                <div class="showdowjones">
                  <div class="showdowjones_pdf">
                    <div class="dowjones_pdf"><a :href="showdowjonesinfo.pdf" target="_blank">导出PDF</a></div>
                  </div>
                  <div class="showdowjones_row flex">
                    <div>檔案 ID 編號:</div>
                    <div>{{showdowjonesinfo.peid}}</div>
                  </div>
                  <div class="showdowjones_row flex">
                    <div>類型:</div>
                    <div>{{showdowjonesinfo.type}}</div>
                  </div>
                  <div class="showdowjones_row flex">
                    <div>性別:</div>
                    <div>{{showdowjonesinfo.gender}}</div>
                  </div>
                  <div class="showdowjones_row">
                    <div>姓名:</div>
                    <div>
                      <div v-for="(item,i) in showdowjonesinfo.names">{{item}}</div>
                    </div>
                  </div>
                  <div class="showdowjones_row">
                    <div>國家:</div>
                    <div>
                      <div v-for="(item,i) in showdowjonesinfo.country">
                        <span>{{item.countrytype}}</span> <span>{{item.country}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="showdowjones_row imggroup">
                    <div>照片:</div>
                    <div>
                      <div v-for="(item,i) in showdowjonesinfo.image"><a :href="item" target="_blank"><img :src="item"></a></div>
                    </div>
                    <div>
                      <div style="margin-bottom: 10px; " v-for="(item,i) in showdowjonesinfo.image"><a style="color: #3399FF;" :href="item" target="_blank">{{item}}</a></div>
                    </div>
                  </div>
                  <div class="showdowjones_row">
                    <div>資料:</div>
                    <div>
                      <div v-for="(item,i) in showdowjonesinfo.watchlist">{{item}}</div>

                    </div>
                  </div>
                  <div class="showdowjones_row">
                    <div>職位:</div>
                    <div>
                      <div v-for="(item,i) in showdowjonesinfo.jobs">
                        <div>{{item.jobtype}}</div>
                        <div>{{item.job}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-dialog>
              <div class="dowjones_pdf" v-show="dowjones_pdf&&dowjones_pdf!=''">
                <div class="pdf-btn-box">
                  <a :href="dowjones_pdf" target="_blank">
                    <img src="@/assets/pdf.png">
                  </a>
                  <div class="pdf-title">Search Result PDF</div>
                </div>
                <template v-for="(item,i) in showdowjones_pdfs">
                  <div class="pdf-btn-box" :key="i">
                    <span v-if="!isreadonly" class="del-btn" @click="deldowjonespdf(item.peid)">
                      <i class="el-icon-circle-close"></i>
                    </span>
                    <a :href="item.fileurl" target="_blank">
                      <img src="@/assets/pdf.png">
                    </a>
                    <div class="pdf-title">檔案編號：{{item.peid}}</div>
                  </div>
                </template>
              </div>
            </div>
            <div v-else>
              <div style="margin-bottom: 20px;">
                <div class="group-sub-title">
                  <h3>OFAC</h3>
                </div>
                <el-table empty-text="暫無數據" :data="examinedata" border :header-cell-style="{background:'#FAFAFA'}">
                  <el-table-column label="Name" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Name</div>
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Address" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Address</div>
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Type" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Type</div>
                      <span>{{scope.row.type}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Program(s)" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Program(s)</div>
                      <span>{{scope.row.program}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="List" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">List</div>
                      <span>{{scope.row.list}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Score" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Score</div>
                      <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                      <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                      <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="url" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">url</div>
                      <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Query Time" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Query Time</div>
                      <span v-if="scope.row.addtime">{{scope.row.addtime}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="margin-bottom: 20px;">
                <div class="group-sub-title">
                  <h3>UNSC</h3>
                </div>
                <el-table empty-text="暫無數據" :data="examinedataxml" border :header-cell-style="{background:'#FAFAFA'}">
                  <el-table-column label="Name" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Name</div>
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Type" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">type</div>
                      <span>{{scope.row.type}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Design" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">design</div>
                      <span>{{scope.row.design}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="Date" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">date</div>
                      <span>{{scope.row.date}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Score" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Score</div>
                      <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                      <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                      <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Url" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">url</div>
                      <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Query Time" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Query Time</div>
                      <span>{{scope.row.addtime}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </template>
          <el-upload disabled action="#" :file-list="files2" list-type="picture-card" :auto-upload="false" :on-preview="viewpic" :on-remove="delpic">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="showpicbox" :append-to-body="true">
            <img width="100%" :src="showpicurl" alt="">
          </el-dialog>
        </div>
      </div>

    </el-form>
  </div>

</template>

<script>

import CustomerFiles from "@/components/CustomerFiles.vue"
export default {
  components: {
    CustomerFiles
  },
  props: {
    data: {
      type: Object,
      default: () => { },
    },
    createinfo: {
      type: Boolean,
      default: true,
    },
  },
  name: "person",
  data () {
    return {
      component_name: 'CustomerFiles',
      isreadonly: true,
      type: 0,
      showpicurl: '',
      showpicbox: false,
      examinedata: [],
      examinedataxml: [],
      files1: [],
      files2: [],
      customer_files2: [],
      dowjones_pdf: '',
      dowjonesdata: [],
      showdowjonesinfo: {},
      showdowjones: false,
      dowjones: true,
      showdowjones_pdfs: [],
    }
  },
  methods: {
    riskicon_color (riskicon) {
      if (riskicon.indexOf('SAN') > -1) {
        return 'riskicon_san';
      } else if (riskicon.indexOf('PEP') > -1) {
        return 'riskicon_pep';
      } else {
        return 'riskicon_other';
      }
    },
    get_examines_status () {
      if (this.examineStatus() == 2) {
        this.dowjones = true;
      } else {
        this.dowjones = false;
      }
    },
    showdowjones_info_fun (peid, type = 0) {
      if (peid) {
        this.loading = true;
        let mso_id = this.data.mso_id?this.data.mso_id:(this.data.orders?this.data.orders.mso_id:0);
        let staff_id = this.data.staff_id?this.data.staff_id:(this.data.orders?this.data.orders.staff_id:0);
        let store_id = this.data.store_id?this.data.store_id:(this.data.orders?this.data.orders.store_id:0);
        this.post('api/order/dowjones_peid', {
          mso_id,
          store_id,
          staff_id,
          peid
        }).then(res => {
          this.loading = false;
          this.showdowjonesinfo = res;
          this.showdowjones = true;
        })
      }
    },
    delpic (file, fileList) {

    },
    viewpic (file) {
      this.showpicurl = file.url;
      this.showpicbox = true;
    },
    copyText (text) {
      const oInput = document.createElement('input')
      oInput.value = text;
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      // 提醒信息
      this.$notify({
        message: '複製成功',
        type: 'success',
        duration: 3000,
        offset: 70
      });
      oInput.remove()
    },

  },
  created () {
    this.get_examines_status();
    this.type = this.data.type;
    this.examinedata = this.data.examinedata;
    this.examinedataxml = this.data.examinedataxml;
    this.dowjonesdata = this.data.dowjonesdata;
    this.dowjones_pdf = this.data.dowjones_pdf;
    this.showdowjones_pdfs = this.data.showdowjones_pdfs;
    this.data.files.map((v) => {
      if (v.type == 1) {
        let temp = {};
        temp.fileurl = v.fileurl;
        temp.url = this.apiurl + v.fileurl;
        temp.id = v.id;
        temp.files_type = v.files_type;
        temp.files_type_id = v.files_type_id;
        this.files1.push(temp);
      } else if (v.type == 2) {
        let file = {
          name: '',
          url: this.apiurl + v.fileurl
        }
        this.files2.push(file);
      }
    })
  }
}
</script>

<style scoped>
.flex50 {
  flex: 0 50%;
}
@media screen and (max-width: 1024px) {
}
</style>
